/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}
